'use strict'

module.exports = require('./types')



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/creditcards-types/index.js
// module id = XnBl
// module chunks = 0